var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowDropDown = function SvgArrowDropDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.325 14.65 8.15 11.475c-.317-.317-.392-.68-.225-1.088.167-.408.475-.612.925-.612h6.35c.433 0 .733.204.9.612.167.409.092.771-.225 1.088L12.7 14.65c-.1.1-.208.17-.325.213a1.034 1.034 0 0 1-.35.062c-.15 0-.28-.02-.387-.062a.907.907 0 0 1-.313-.213"
  })));
};
export default SvgArrowDropDown;